export default __webpack_public_path__ + "static/media/line3.5907b1f8.svg";